import { defineStore } from 'pinia'
import api from '@/api/axios'
import CategoryEntity from '@/entities/categoryEntity'
import {
    confirmCategoriesImport as confirmCategoriesImportRequest,
    previewCategoriesImport as previewCategoriesImportRequest,
} from '@/utils/categoryImport.mjs'

export const useCategoriesStore = defineStore('categories', {
    state: () => ({
        categories: {
            items: [],
            count: 0
        },
        currentCategory: null,
        pageSize: 20,
    }),
    getters: {
        allCategories: (state) => Array.isArray(state.categories.items) ? state.categories.items : [],
        countPages: (state) => Math.ceil(state.categories.count / state.pageSize) || 1,
    },

    actions: {
        async getCategories(page = 1, filter = {}, limit = null) {
            try {
                const query = {
                    ...filter,
                    limit: limit === null ? this.pageSize : limit,
                    page,
                };
                const urlFilter = new URLSearchParams(query).toString();
                const response = await api.get('/category?' + urlFilter);
                const items = CategoryEntity.fromBackendCollection(response.data?.items || []);
                this.categories = {
                    ...response.data,
                    items,
                    count: Number(response.data?.count) || 0,
                };
            } catch (error) {
                console.error('Failed to fetch providers:', error);
                throw error;
            }
        },
        async getCategoriesOptions(filter = {}, limit = 1000) {
            try {
                const query = {
                    ...filter,
                    limit,
                    page: 1,
                };
                const urlFilter = new URLSearchParams(query).toString();
                const response = await api.get('/category?' + urlFilter);
                const items = Array.isArray(response.data?.items) ? response.data.items : [];
                return CategoryEntity.fromBackendCollection(items);
            } catch (error) {
                console.error('Failed to fetch categories options:', error);
                throw error;
            }
        },
        async getCategory(id) {
            try {
                const response = await api.get(`/category/${id}`);
                this.currentCategory = CategoryEntity.fromBackend(response.data);
            } catch (error) {
                console.error('Failed to fetch provider:', error);
                throw error;
            }
        },
        async addCategory(categoryData) {
            try {
                const payload = CategoryEntity.toBackendPayload(categoryData);
                const response = await api.post('/category', payload);
                const createdEntity = CategoryEntity.fromBackend(response.data);
                if (!Array.isArray(this.categories.items)) {
                    this.categories.items = [];
                }
                this.categories.items.push(createdEntity);
                this.categories.count += 1;
                this.currentCategory = createdEntity;
                return createdEntity;
            } catch (error) {
                console.error('Failed to add category:', error);
                throw error;
            }
        },
        async updateCategory(id, categoryData) {
            try {
                const payload = CategoryEntity.toBackendPayload(categoryData);
                const response = await api.put(`/category/${id}`, payload);
                const updatedEntity = CategoryEntity.fromBackend(response.data);
                const index = this.categories.items.findIndex((category) => String(category.id) === String(id));
                if (index !== -1) {
                    this.categories.items[index] = updatedEntity;
                }
                this.currentCategory = updatedEntity;
                return updatedEntity;
            } catch (error) {
                console.error('Failed to update provider:', error);
                throw error;
            }
        },
        async previewCategoriesImport(file, mapping) {
            try {
                return await previewCategoriesImportRequest(api, file, mapping);
            } catch (error) {
                console.error('Failed to preview categories import:', error);
                throw error;
            }
        },
        async confirmCategoriesImport(sessionId) {
            try {
                return await confirmCategoriesImportRequest(api, sessionId);
            } catch (error) {
                console.error('Failed to confirm categories import:', error);
                throw error;
            }
        },
        //
        // async deleteProvider(id) {
        //     try {
        //         await api.delete(`/providers/${id}`);
        //         this.providers = this.providers.filter((p) => p.id !== id);
        //     } catch (error) {
        //         console.error('Failed to delete provider:', error);
        //         throw error;
        //     }
        // },
    },
});
